import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { resolveInstallOrder } from '@core-engine/installable/protocol/resolve-install-order.js'
import { getIntegrationDefinition } from '@next-adapter/integration-registry.js'

export function resolveIntegrationInstallOrder(
  integrationIds: BetterstartIntegrationId[]
): BetterstartIntegrationId[] {
  return resolveInstallOrder(
    integrationIds,
    (integrationId) => getIntegrationDefinition(integrationId).dependencies,
    'integration'
  )
}
